import styled from 'styled-components';
export const ToolCallInlineRowContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  flex-shrink: 0;
`;
